import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useCallback,
} from "react";
import { Logout, verify } from "../services/loginServices";

const AuthContext = createContext();

function AuthProvider({ children }) {
  const [userData, setUserData] = useState({
    username: "",
    email: "",
  });
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  function login(user) {
    try {
      setUserData(user);
      setIsAuthenticated(true);
    } catch (err) {
      console.error("Login state update error: ", err);
    }
  }

  const logout = async () => {
    try {
      setIsLoading(true);
      await Logout();
      setIsAuthenticated(false);
      setUserData(null);
    } catch (err) {
      console.error("Logout error: ", err);
      setIsAuthenticated(false);
      setUserData(null);
    } finally {
      setIsLoading(false);
    }
  };

  const checkAuth = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await verify(); // either { user } or null

      if (response && response.user) {
        setUserData(response.user);
        setIsAuthenticated(true);
      } else {
        setUserData(null);
        setIsAuthenticated(false);
      }
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  return (
    <AuthContext.Provider
      value={{
        login,
        isAuthenticated,
        isLoading,
        logout,
        checkAuth,
        userData,
        setUserData,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}

export { useAuth, AuthProvider };
